<template>
  <div
    class="cell-personal-account"
    :class="{ 'cell-personal-account_disabled': !canEdit }"
    @click="canEdit && (isShowPersonalAccountTransactionModal = true)"
  >
    <m-personal-account-transactions
      :active="isShowPersonalAccountTransactionModal"
      :record="record"
      :personalReasons="personalReasons"
      :calculation-type="calculationType"
      @close="isShowPersonalAccountTransactionModal = false"
      @submitPersonalAccountTransactionValue="setPersonalAccountTransactionValue"
    />
    <div
      :class="{
        'cell-personal-account-value-grey': record.personal_account_transactions.value === 0,
        'cell-personal-account-value-green': record.personal_account_transactions.value > 0,
        'cell-personal-account-value-red': record.personal_account_transactions.value < 0,
      }"
      class="cell-personal-account-value"
    >
      {{ numberWithSpaces(record.personal_account_transactions.value) }}
    </div>
  </div>
</template>

<script>
import PersonalAccountTransactionModal from "@/pages/calculations/create/additions/modal-production-personal-account-transactions";

export default {
  name: "production-cell-personal-account-transactions",
  components: {
    "m-personal-account-transactions": PersonalAccountTransactionModal,
  },
  props: ["record", "calculationType", "calculationData", "personalReasons", "canEdit"],
  data() {
    return {
      isShowPersonalAccountTransactionModal: false,
    };
  },
  methods: {
    setPersonalAccountTransactionValue(params) {

      this.record.personal_account_transactions.items = params.items.map((item) => ({
        type: item.switcherLocal === "charge" ? "+" : "-",
        amount: item.amountLocal,
        amountLocalError: "",
        comment: item.commentLocal,
        reason_id: item.reasonLocal2 ? item.reasonLocal2.value : null
      }));


      let minus=0; let plus=0;
      this.record.personal_account_transactions.value = params.items.reduce((acc, item) => {
        if (item.switcherLocal === "charge") {
          acc += Number(item.amountLocal);
          plus += Number(item.amountLocal);
        } else {
          acc -= Number(item.amountLocal);
          minus += Number(item.amountLocal);          
        }
        return acc;
      }, 0); 
      this.record.personal_account_transactions.value = Math.round(this.record.personal_account_transactions.value*100)/100;

      if (this.calculationType === "byPeriod") {

      }

      let personal_history = [];
      if (this.calculationType === "byPeriod") {
        const findWorker = this.calculationData.period.production.workers.findIndex(
          (worker) => worker.worker_id === this.record.id,
        );
        if (findWorker !== -1) {
          personal_history = this.calculationData.period.production.workers[findWorker].personal_history
            ? this.calculationData.period.production.workers[findWorker].personal_history
            : [];
        }
      }

      let sumFines = 0;
      let sumPrizes = 0;
      this.record.prize.items.forEach((item) => {
        if (!item.is_external) sumPrizes += Number(item.amount);
      });
      this.record.fine.items.forEach((item) => {
        if (!item.is_external) sumFines += Number(item.amount);
      });

      if (this.calculationType === "byPeriod") {
        this.record.to_payoff.value =Number(this.record.balance.value) + plus - minus + sumPrizes - sumFines; //к выплате
        this.record.total_accrued.value =Number(this.record.personal_account_accrued.value) + plus + sumPrizes; //всего начислено
        this.record.already_paid.value =Number(this.record.personal_account_removed.value) + minus + sumFines; //всего списано
        this.record.personal_account_balance.value = (this.record.personal_account_balance_start ? this.record.personal_account_balance_start : 0)+ plus - minus + sumPrizes - sumFines; //остаток на лс 

        this.record.to_payoff.value = Math.round(this.record.to_payoff.value*100)/100;
        this.record.total_accrued.value = Math.round(this.record.total_accrued.value*100)/100;
        this.record.already_paid.value = Math.round(this.record.already_paid.value*100)/100;
        this.record.personal_account_balance.value = Math.round(this.record.personal_account_balance.value*100)/100;

        this.$emit("updateKPItable");
      }
      console.log("recode!!!", this.record);
      this.$emit("updatePersonal", {record:this.record});

    },
    
    numberWithSpaces(x) {
      if (x > 0) {
        return `+${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (x < 0) {
        return `-${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
.cell-personal-account {
  line-height: 13px;
  font-size: 13px;
  padding: 10px;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;

  &:hover {
    outline-style: solid;
    outline-width: 1px !important;
    outline-color: #0066ff !important;
    box-shadow: 0 0 10px rgba(0, 102, 255, 0.4);
  }

  &_disabled {
    cursor: default;

    &:hover {
      outline: none;
      box-shadow: none;
    }
  }

  &-value {
    white-space: nowrap !important;

    &-grey {
      color: #8e9cbb;
    }
    &-green {
      color: #12c971;
    }
    &-red {
      color: #ff238d;
    }
  }
}
</style>
